import React, { Component } from 'react'
import { getQuantity,getDescription,getPacking,getMask,getShipper,getShippingBehalf,getNetWeight,
  getLoadingDate,getPlaceLoading,getShippingPort,getCarrayVessel,getDestination,getGrossWeight,
  getTareWeight,getExportLicense,addCommaInNumber,getEachNetWeight,getEachGrossWeight } from '../../helpers/function';
import { Container,Button } from 'react-bootstrap';
import { AdminNav } from '../../helpers';
import jsPDF from 'jspdf';
import OrderHealthCert  from '../../components/Order/OrderHealthCert';
// import certificateForm from './checkweightform.jpeg'
import axios from 'axios';
export default class HealthCert extends Component {
  constructor(props) {
    super(props);
    this.state = {
      CertificateSheetData : {},
      Token : 'token',
      redirect : false,
      CertificateSheetDataOnline : null
    } 
    this.handleCertificate = this.handleCertificate.bind(this)
    this.handleDescription = this.handleDescription.bind(this)    
  }

  // componentWillMount(){
  //   // let viewCheckWeightSheetByLicenseID = axios.post(
  //   //   'https://us-central1-riceinspection-16b06.cloudfunctions.net/middleWare',
  //   //   {
  //   //     action: 'viewCertificateSheetByLicenseID',
  //   //     data: { 
  //   //       'jobID' : this.props.location.state['jobID'],
  //   //       'licenseID': this.props.location.state.description[this.props.location.pageIndex]['licenseID'] 
  //   //     },
  //   //   }
  //   // )
  // }   
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    // return { redirect: true };
  }

  handleDescription(e,idx){
    let id = e.target.id
    let value = e.target.value
    console.log(this.state)
    this.setState({
      ...this.state,
      CertificateSheetDataOnline :{
        ...this.state.CertificateSheetDataOnline,    
        Certificate : {
          ...this.state.CertificateSheetDataOnline.Certificate,
          description : {
            ...this.state.CertificateSheetDataOnline.Certificate.description,
            [idx]:{
              ...this.state.CertificateSheetDataOnline.Certificate.description[idx],
              [id] : value
            }
          }
        }
      }})
  }
  handleCertificate(e){
    console.log(this.state)
    let id = e.target.id
    let value = e.target.value
    console.log(id)
    console.log(value)
    let tempData = {
      ...this.state,
      CertificateSheetDataOnline :{
        ...this.state.CertificateSheetDataOnline,
        Certificate : {
          ...this.state.CertificateSheetDataOnline.Certificate,
          [id] : value
        }
    }}
    console.log(tempData)
    this.setState({
      ...this.state,
      CertificateSheetDataOnline :{
        ...this.state.CertificateSheetDataOnline,
        Certificate : {
          ...this.state.CertificateSheetDataOnline.Certificate,
          [id] : value
        }
    }})
  }
  
  async printOutCertificate (idx,generalDescription) {

    let doc = new jsPDF('p', 'mm', [840.51, 595.40])

    // doc.addImage(image, 'JPEG', 0, 0, 210, 297);
        // doc.save('test.pdf')
    doc.setFont('Times','Roman')
    doc.setFontSize(11)
    let handleData = generalDescription.description[idx]
    let CheckWeightSheet = generalDescription
    let firstHeight = 78
    let heightConst = 8
    function getHeight(x,y){
      if(y){
        return firstHeight + (heightConst*x) + y
      }else{
        return firstHeight + (heightConst*x)
      }
    }
    doc.setFontSize(14)
    doc.text(handleData['No'],29,59.5)
    doc.setFontSize(11)
    doc.text(CheckWeightSheet['currentDate'], 133, 59.5)
    doc.setFontSize(6)
    if(parseInt(CheckWeightSheet['currentDate'].split(" ")[0])==1){
      doc.text(`st`, 134.7, 57.5)
    }
    else if(parseInt(CheckWeightSheet['currentDate'].split(" ")[0])==2){
      doc.text(`nd`, 134.7, 57.5)
    }
    else if(parseInt(CheckWeightSheet['currentDate'].split(" ")[0])==3){
      doc.text(`rd`, 134.7, 57.5)
    }
    else if(parseInt(CheckWeightSheet['currentDate'].split(" ")[0])<10){
      doc.text(`th`, 134.7, 57.5)
    }
    else if(parseInt(CheckWeightSheet['currentDate'].split(" ")[0])==21 || parseInt(CheckWeightSheet['currentDate'].split(" ")[0])==31){
      doc.text(`st`, 137, 57.5)
    }
    else if(parseInt(CheckWeightSheet['currentDate'].split(" ")[0])==22){
      doc.text(`nd`, 137, 57.5)
    }
    else if(parseInt(CheckWeightSheet['currentDate'].split(" ")[0])==23){
      doc.text(`rd`, 137, 57.5)
    }
    else if(parseInt(CheckWeightSheet['currentDate'].split(" ")[0])>=10){
      doc.text(`th`, 137, 57.5)
    }
    doc.setFontSize(11) 
    doc.text('This is to certify that the following rice shipment:-', 35, firstHeight-10)
    doc.text('Quantity : ',19,firstHeight) 
    doc.text(handleData['bagQuantity'],70,firstHeight)
    let height = 1
    doc.text('Description of goods : ',19,getHeight(height))
    doc.text(handleData['riceTypeID'],70,getHeight(height))
    height += 1
    doc.text('Packing : ',19,getHeight(height))
    doc.text(handleData['PackingType1'],70,getHeight(height))
    height += 1
    if(handleData['PackingType11'] !== '-'){
      doc.text(handleData['PackingType11'],70,getHeight(height))
      height += 1
    }
    if(handleData['PackingType12'] !== '-'){
      doc.text(handleData['PackingType12'],70,getHeight(height))
      height += 1
    }

    doc.text(handleData['PackingType2'],70,getHeight(height))
    height += 1
    doc.text('Weight: ',19,getHeight(height))
    doc.text(handleData['PackingType2'],70,getHeight(height))
    height += 1
    doc.text('Mark: ',19,getHeight(height))
    doc.text(handleData['logo'],75,getHeight(height))
    height += 1
    doc.text('Shipper: ',19,getHeight(height))
    doc.text(CheckWeightSheet['companyEN'],70,getHeight(height))
    height += 1
    doc.text(CheckWeightSheet['companyEN'],70,getHeight(height))
    height += 1
    doc.text(CheckWeightSheet['companyEN'],70,getHeight(height))
    height += 1
    doc.text('Shipped on board date:',19,getHeight(height))
    doc.text(handleData['ShipperBehalf'],75,getHeight(height))
    height += 1
    doc.text('Ex godown:',19,getHeight(height))
    doc.text(handleData['ShipperBehalf'],75,getHeight(height))
    height += 1
    doc.text('Port of loading:',19,getHeight(height))
    doc.text(handleData['ShipperBehalf'],75,getHeight(height))
    height += 1
    doc.text('Vessel name:',19,getHeight(height))
    doc.text(handleData['ShipperBehalf'],75,getHeight(height))
    height += 1
    doc.text('Destination:',19,getHeight(height))
    doc.text(handleData['ShipperBehalf'],75,getHeight(height))
    height += 1
    doc.text('I have dream that be great cause it be power things I think it could give our power and brave for us. at least it will be power for nex generation people. I think it could give our power and brave for us. at least it will be power for I think it could give our power and brave for us. at least it will be power for', 19, getHeight(height), {maxWidth: 180, align: 'justify'});

  }
  renderRedirectToJob(){
    if(this.state.redirect){ 
      // this.props.history.location.state
      this.props.history.push({
        pathname: '/CertificateTable',
        // state: this.props.location.state.shippingDate,
      })
    }
  }
  createCertificate(idx,data){
   let prepareData = {}
    const arr = ['currentDate','shippingDate','godown','shippingPort','Quality1','Quality2','Weight','title1','companyEN']
    const arrDes = ['No','bagQuantity','riceTypeID','PackingType1','PackingType11','PackingType12','PackingType2','logo','ShipperBehalf','destinationCity','vehicleName','TotalGross','TotalTare','TotalNett','License']
    arr.map((title)=>{
      prepareData[title] = data[title] 
    })
    arrDes.map((title)=>{
      prepareData[title] = data['description'][idx][title]
    })
    prepareData['jobID'] = data['jobID']
    prepareData['License'] = `030811${prepareData['License']}`
    prepareData['subID'] = `${idx}`

    axios.post(
      'https://us-central1-riceinspection-16b06.cloudfunctions.net/middleWare',
      {
        action: 'createCertificateSheet',
        data: prepareData,
      }
    ).then((res)=>{
      if(res.data){
        if(res.data.status == 'new'){
          alert('เพิ่มข้อมูลสำเร็จ')
        }else{
          alert('แก้ไขข้อมูลสำเร็จ')
        }
      }else{
        alert('เกิดข้อผิดพลาด')
      }
    })
  } 
  render() {
    if(!this.state.redirect){
      return (
        <Container>
          <AdminNav/>
          {this.renderRedirectToJob()}
          <div style={{width:'100%',alignContent:'left',textAlign:'left',fontSize:'22px'}}  >
              {/* <a href="javascript:void(0)" onClick={()=>{this.setState({
                ...this.state,
                redirect : true
              })}}> {`<`} ย้อนกลับ 
              </a>  */}
          </div>  
          <OrderHealthCert /> 
        </Container> 
      )}
    else{
      return <div>          {this.renderRedirectToJob()}
      </div>
    }
  }
} 
